import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import {connect} from 'react-redux';
import ScreenReaderOnly from '../../UI/ScreenReaderOnly/ScreenReaderOnly';
import CharCounter from '../components/ui/CharCounter';
import Translation from '../lang/Translation';
import getExperimentCollapsedOptionalFields from '../selectors/getExperimentCollapsedOptionalFields';
import {getSiteCode} from '../selectors/selectors';
import useStyles from './FieldLabel.styles';

export function FieldLabelPresentational(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  const cleanedValue = props.validationCleaner ? props.validationCleaner(props.value) : props.value;

  const label = (
    <label
      htmlFor={props.htmlFor}
      className={classes.fieldLabel}
      aria-label={props.required ? `${props.htmlFor} - required` : `${props.htmlFor} - optional`}
      data-test="Label"
    >
      <Translation optionalExtension={props.siteCode}>{props.label}</Translation>
      {
        props.fieldType !== 'checkbox' && !props.required && props.shouldHideCollapsedOptionalFields && !props.shouldNotShowFieldOptionalLabel && (
          <span className={classes.optional} id="label-optional">
            <Translation optionalExtension={props.siteCode}>delivery.address.label.optional</Translation>
          </span>
        )
      }
    </label>
  );
  
  return (
    <>
      {(!(props.shouldHideCollapsedOptionalFields && props.hideLabel) && (props.hideLabel ? <ScreenReaderOnly>{label}</ScreenReaderOnly> : label))}
      
      <CharCounter
        length={cleanedValue ? cleanedValue.length : 0}
        maxLength={props.maxLength}
        fixedLength={props.fixedLength}
      />
    </>
  );
}

FieldLabelPresentational.propTypes = {
  label: PropTypes.string,
  htmlFor: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.string,
  maxLength: PropTypes.number,
  fixedLength: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  siteCode: PropTypes.string.isRequired,
  hideLabel: PropTypes.bool,
  validationCleaner: PropTypes.func,
  isRadioButton: PropTypes.bool,
  type: PropTypes.string,
  shouldHideCollapsedOptionalFields: PropTypes.bool,
  fieldType: PropTypes.string,
  shouldNotShowFieldOptionalLabel: PropTypes.bool,
  fieldCollapsed: PropTypes.bool,
};

const mapStateToProps = state => ({
  siteCode: getSiteCode(state),
  shouldHideCollapsedOptionalFields: getExperimentCollapsedOptionalFields(state),
});

export default connect(mapStateToProps)(FieldLabelPresentational);
